const getFillTransitionValue = ({
  fillDuration, fillEasing, fillStaggerStep, fillDelay, i,
}) => `fill ${parseFloat(fillDuration)}s ${fillEasing} ${i * parseFloat(fillStaggerStep) + parseFloat(fillDelay)}s`

export default getFillTransitionValue
